// extracted by mini-css-extract-plugin
module.exports = {"specialInstructions":"SpecialInstructions__specialInstructions___PawLS"};